import { StyleSheet } from "react-native";
import { theme } from "@clearabee/ui-library-native";

export const styles = StyleSheet.create({
  image: {
    padding: theme.spacing.medium,
    borderRadius: theme.spacing.xsmall,
    width: 215,
    height: 110,
    alignItems: "center",
    justifyContent: "center",
  },
});
